import React from 'react';
import { Popup, Select } from 'semantic-ui-react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';

import { caseInsensitiveFilter } from 'Common/GridHelper';

const ImportFilePreviewComponent = props => {
  const {
    keyValues,
    getPreparedData,
    columns,
    options,
    error,
    getValue,
    addData,
  } = props;
  let cog = null;
  return (
    <div className="form--file-preview">
      {keyValues && (
        <div>
          <ReactTable
            data={getPreparedData()}
            resizable={false}
            showPagination={true}
            defaultPageSize={10}
            className="-striped -highlight lg-width"
            defaultFilterMethod={caseInsensitiveFilter}
            columns={columns.map((fieldData, i) => {
              const optionObj = getValue(i);
              return {
                Header: (
                  <Popup
                    trigger={
                      <Select
                        search
                        options={options}
                        onChange={(event, data) => {
                          addData(event, data, i);
                        }}
                        error={error}
                        onOpen={e => {
                          cog =
                            e &&
                            e.currentTarget &&
                            e.currentTarget.closest('.rt-th');
                          if (cog) {
                            cog.style.zIndex = 2;
                            cog.style.overflow = 'inherit';
                          }
                        }}
                        onClose={() => {
                          if (cog) {
                            cog.style.zIndex = null;
                            cog.style.overflow = 'hidden';
                          }
                        }}
                        value={optionObj.value}
                      />
                    }
                    on="hover"
                    wide
                    inverted
                    className="pop-up--container"
                  >
                    {optionObj.text}
                  </Popup>
                ),
                accessor: 'row' + i,
              };
            })}
          />
        </div>
      )}
    </div>
  );
};
ImportFilePreviewComponent.propTypes = {
  keyValues: PropTypes.array.isRequired,
  getPreparedData: PropTypes.func,
  columns: PropTypes.array.isRequired,
  options: PropTypes.array,
  error: PropTypes.bool,
  getValue: PropTypes.func,
  addData: PropTypes.func,
};

export default ImportFilePreviewComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/components/ImportFilePreview.js